import { Routes } from '@angular/router';
import { AdmsectionListComponent } from './admsection-list/admsection-list.component';
import { AdmsectionFormComponent } from './admsection-form/admsection-form.component';

export const ADMSECTION_ROUTES: Routes = [
    { path: 'list/:idtier3', component: AdmsectionListComponent },
    { path: 'add/:idtier3', component: AdmsectionFormComponent },
    { path: 'edit/:id', component: AdmsectionFormComponent },
    { path: 'getidtier1', component: AdmsectionFormComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'list' }
];